export const DOBRegex = /(\d{2})\/(\d{2})\/(\d{4})/;
